import { createContainer, createStore } from 'react-sweet-state';
import * as actions from './actions';
import { DEFAULT_ORDER_DIRECTION, DEFAULT_ORDER_FIELD } from './constants';
export var store = createStore({
  name: 'issue-attachments',
  initialState: {
    issueAttachments: {},
    meta: {
      orderDirection: DEFAULT_ORDER_DIRECTION,
      orderField: DEFAULT_ORDER_FIELD,
      startAt: 0,
      isDeleteAllDialogOpen: false
    }
  },
  actions: actions
});
export var IssueAttachmentStoreContainer = createContainer(store);